import React from "react";

import useAdminPayment from "../hooks/useAdminPayment";
import AdminPayment from "../components/AdminPayment";

const AdminPaymentInterface = function (props) {
  const { onCancelAction } = props;
  const {
    name,
    account,
    payments,
    owner,
    editMode,
    submitting,
    stripe_payout_amount,
    stripe_payout_currency,
    stripe_payout_id,
    stripe_payout_status,
    onNameChange,
    onOwnerNameChange,
    onAccounthange,
    onPostItem,
    onDelete,
    onRefreshData,
    // apiError,
  } = useAdminPayment(props);
  return (
    <AdminPayment
      name={name}
      account={account}
      owner={owner}
      payments={payments}
      editMode={editMode}
      submitting={submitting}
      stripe_payout_amount={stripe_payout_amount}
      stripe_payout_currency={stripe_payout_currency}
      stripe_payout_id={stripe_payout_id}
      stripe_payout_status={stripe_payout_status}
      onNameChange={onNameChange}
      onOwnerNameChange={onOwnerNameChange}
      onAccounthange={onAccounthange}
      onPostItem={onPostItem}
      // onEdit={onEdit}
      onDelete={onDelete}
      onCancelAction={onCancelAction}
      // apiError={apiError}
      onRefreshData={onRefreshData}
    />
  );
};

export default AdminPaymentInterface;
